import React from 'react';
import ReactDOM from "react-dom/client";
import DesignTool from "./DesignTool.jsx";

const appNode = document.getElementById('customizer');
const root = ReactDOM.createRoot(appNode);

root.render(<DesignTool/>);